import { Unstable_Grid2 as Grid, Stack } from '@mui/material';

import { Select, TextField } from '@occc-app/design-system';
import { parseNumber } from '@occc-app/lib/finalFormUtils';

import { sliderOperatorOptions } from './constants';
import { AudienceSurveyResponseSliderOperator } from './types';
import { getSurveysFieldName } from './utils';
import { MEMBER_RESPONDED_WITH_LABEL } from './copies';
import { FieldTitle } from './FieldTitle';

export type SurveySliderFormControlsProps = {
  fieldNamePrefix: string;
  sliderOperator: AudienceSurveyResponseSliderOperator;
};

export const SurveySliderFormControls = ({
  fieldNamePrefix,
  sliderOperator,
}: SurveySliderFormControlsProps) => {
  return (
    <Stack>
      <FieldTitle label={MEMBER_RESPONDED_WITH_LABEL} />

      <Grid container columnSpacing={3} rowSpacing={2} paddingTop={2}>
        <Grid xs={6}>
          <Select
            name={getSurveysFieldName(fieldNamePrefix, 'sliderOperator')}
            label='Target'
            data={sliderOperatorOptions}
            formControlProps={{ size: 'medium', margin: 'none' }}
          />
        </Grid>

        {sliderOperator === 'is-between' && (
          <>
            <Grid xs={3}>
              <TextField
                name={getSurveysFieldName(fieldNamePrefix, 'minValue')}
                label='Minimum'
                fieldProps={{
                  parse: parseNumber,
                }}
              />
            </Grid>

            <Grid xs={3}>
              <TextField
                name={getSurveysFieldName(fieldNamePrefix, 'maxValue')}
                label='Maximum'
                fieldProps={{
                  parse: parseNumber,
                }}
              />
            </Grid>
          </>
        )}

        {sliderOperator !== 'is-between' && (
          <Grid xs={6}>
            <TextField
              name={getSurveysFieldName(fieldNamePrefix, 'value')}
              label='Value'
              fieldProps={{
                parse: parseNumber,
              }}
            />
          </Grid>
        )}
      </Grid>
    </Stack>
  );
};
